export default class ReviewsAndRatings {
  constructor(NPI) {
    if (NPI) {
      this.NPI = NPI;
    } else {
      this.NPI = '-1';

      const npiSelector = document.querySelector(
        '.field--name-field-provider-npi-number.field__item',
      );

      if (npiSelector) {
        this.NPI = npiSelector.textContent;
      }
    }
    this.start = 0;

    this.STARS_ONLY_WIDGET = `https://widgets.reputation.com/widgets/5d51554bf35e671c67694053/run?tk=41a5eb11b43&lk=${this.NPI}`;
  }

  fetchRatingsAndReviews($) {
    this.starsOnlyWidget($);
    this.reviewsWidget($);
  }

  addStarRatingToOverallSelector($, selector, response) {
    if (selector.children.length < 1) {
      const parser = new DOMParser();
      selector.prepend(
        parser.parseFromString(response, 'text/html').body.firstElementChild,
      );
      document
        .querySelectorAll('.provider-star-ratings .rating .count span')
        .forEach(element => {
          element.textContent = ` ${
            $(`#ratings-label-${this.NPI}`)[0].textContent
          }`;
        });
    }
  }

  setStarRating($, response) {
    if (response) {
      if (response.indexOf('error-container') < 1) {
        const $overallSelector = document.querySelectorAll(
          `#overall-${this.NPI}`,
        );
        if ($overallSelector.length > 0) {
          $overallSelector.forEach(selector => {
            this.addStarRatingToOverallSelector($, selector, response);
          });
        } else {
          $('.overall-star-rating').prepend(response);
        }
      } else {
        this.showNoReviewLink();
      }
    }
  }

  setReviews($, response) {
    $('#reviews').html(response);

    const next = document.querySelectorAll(
      '.field--name-field-review-pagination-next .field__item',
    );
    const prev = document.querySelectorAll(
      '.field--name-field-pagination-previous .field__item',
    );
    const survey = document.querySelectorAll(
      '.field--name-field-survey-response-label .field__item',
    );
    const nextText = next[next.length - 1].innerHTML;
    const prevText = prev[prev.length - 1].innerHTML;
    const surveyText = survey[survey.length - 1].innerHTML;

    const $nextButton = $('.pagination .next-page a');
    const $prevButton = $('.pagination .previous-page a');

    $nextButton.addClass('base-button underline');
    $prevButton.addClass('base-button underline');
    $nextButton.html(nextText);
    $prevButton.html(prevText);
    $('.reviewer .reviewer-name').html(surveyText);
    // add separator with css so we can style it
    $('.summary .info .separator').html('');
    this.setListeners($);
  }

  showNoReviewLink() {
    const providerProfileNoRatingsLink = document.querySelectorAll(
      '.field--name-field-no-ratings-link .field__item a',
    );
    const schedulingResultsNoRatingsLink = document.querySelectorAll(
      `#no-star-${this.NPI} a`,
    );
    const noRatingsLink =
      providerProfileNoRatingsLink.length > 0
        ? providerProfileNoRatingsLink
        : schedulingResultsNoRatingsLink;

    if (noRatingsLink.length > 0) {
      document
        .querySelectorAll('.field--name-field-ratings-label')
        .forEach(ratings => {
          ratings.classList.add('hidden');
        });
      noRatingsLink.forEach(link => {
        link.classList.remove('hidden');
        link.closest('.no-star-ratings').classList.remove('hidden');
      });
    }
  }

  static hideProviderProfileSection() {
    document.querySelector('.reviews-and-ratings').classList.add('hidden');

    // recalculate hiding the last hidden section in case this loaded after
    const lastProviderSections = document.querySelectorAll(
      '.provider-section:not(.hidden)',
    );
    lastProviderSections[lastProviderSections.length - 1].classList.add(
      'last-provider-section',
    );
  }

  starsOnlyWidget($) {
    fetch(this.STARS_ONLY_WIDGET)
      .then(response => {
        if (response.status === 404) {
          this.showNoReviewLink();
          return null;
        }
        return response.text();
      })
      .then(response => {
        this.setStarRating($, response);
      })
      .catch(() => {
        // needed for testing
      });
  }

  reviewsWidget($) {
    const REVIEWS_WIDGET = `https://widgets.reputation.com/widgets/5dceae0bafae734a7ee24e7d/run?tk=41a5eb11b43&start=${this.start}&lk=${this.NPI}`;

    fetch(REVIEWS_WIDGET)
      .then(response => {
        if (response.status === 404) {
          this.showNoReviewLink();
          ReviewsAndRatings.hideProviderProfileSection();
          return null;
        }

        return response.text();
      })
      .then(response => this.setReviews($, response))
      .catch(() => {
        // needed for testing
      });
  }

  setListeners($) {
    const paginationLinks = document.querySelectorAll('.reviews .pagination a');

    paginationLinks.forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        this.updateReviewPagination($, event.target);
      });
      link.addEventListener('keypress', event => {
        event.preventDefault();
        this.updateReviewPagination($, event.target);
      });
    });
  }

  updateReviewPagination($, element) {
    const href = element.href;
    const searchParams = new URLSearchParams(href);
    this.start = searchParams.get('start');
    this.reviewsWidget($);
  }
}

(() => {})(Drupal);
